import { ThunkDispatch } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShowForms } from "../../Service/Apis";
import { setIsLoading } from "../../store/LoadingSlice";
import { RootState } from "../../store/Store";
import {
  FetchDataFailureAction,
  FetchDataSuccessAction,
  fetchData,
} from "../../store/actions";
import AppraisalViewForm from "./AppraisalViewForm";
import FeedBackViewForm from "./FeedBackForm/FeedBackViewForm";
import ThreeSixtyViewForm from "./ThreeSixtyForm/ThreeSixtyViewForm";

interface FormType {
  created_by: string;
  creator_email: string;
  creator_name: string;
  employee_deadline: string;
  form_description: string;
  form_id: string;
  form_name: string;
  is_360: boolean;
  is_appraisal: boolean;
  is_hierarchical: boolean;
  is_uploaded: boolean;
  manager_deadline: string;
  teams: [];
}

const AllFormView = () => {
  const [formDetails, setFormDetails] = useState<FormType[]>([]);
  const isLoading = useSelector((state: any) => state.loading.isLoading);
  const dispatch = useDispatch();
  const formId =
    useSelector((state: any) => state.form.id) ||
    localStorage.getItem("formid");
  const dispatch2: ThunkDispatch<
    RootState,
    null,
    FetchDataSuccessAction | FetchDataFailureAction
  > = useDispatch();
  //fetching the form
  useEffect(() => {
    const fetchAppraisalForm = async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await dispatch2(
          fetchData(`${ShowForms}?form_id=${formId}`)
        );
        setFormDetails(response as FormType[]);
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false));
      }
    };
    fetchAppraisalForm();
  }, []);

  if (formDetails[0]?.is_hierarchical) {
    return (
      <>
        <AppraisalViewForm />
      </>
    );
  } else if (formDetails[0]?.is_360) {
    return (
      <>
        <ThreeSixtyViewForm />
      </>
    );
  } else if (
    !formDetails[0]?.is_appraisal &&
    !formDetails[0]?.is_hierarchical
  ) {
    return (
      <>
        <FeedBackViewForm />
      </>
    );
  }
};

export default AllFormView;
